import { P0, S, abs, fillAt, limb, quad } from '../../geometry';

export const sprout = {
  name: 'Sprout',
  colors: ['#C46A3E', '#2F9E5B'],
  draw(m, t) {
    const pot = [
      [27, 52],
      [30, 70],
      [35, 82],
      [65, 82],
      [70, 70],
      [73, 52],
    ];
    let bend = 2 * S(t * 1.4),
      top = 24,
      lf = { l: 4 * S(t * 1.8), r: 4 * S(t * 1.8 + 1) },
      pose = P0();
    if (m === 'happy') {
      bend = 3 * S(t * 7);
      lf = { l: -14 + 10 * S(t * 9), r: 14 - 10 * S(t * 9 + 1) };
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: sways while the leaves flutter in turn.
    if (m === 'thinking') {
      bend = 8 * S(t * 1.2);
      lf = { l: 14 * S(t * 4), r: 14 * S(t * 4 + 1.6) };
    }
    if (m === 'talking') lf = { l: 9 * S(t * 8), r: 9 * S(t * 8 + 1.7) };
    if (m === 'surprised') {
      top = 16;
      lf = { l: -24 + 3 * S(t * 24), r: 24 };
      bend = 0;
    }
    if (m === 'paused') {
      bend = -14 + S(t * 0.8);
      top = 30;
      lf = { l: 40, r: 30 };
    }
    const stem = quad(
        [50, 50],
        [50 + bend * 0.3, (50 + top) / 2],
        [50 + bend, top],
        4
      ),
      tip = stem[3];
    const leaf = (dir, rotDeg) => {
      const a = (dir < 0 ? 200 : -20) + rotDeg * (dir < 0 ? 1 : -1);
      return [
        tip,
        ...limb(tip[0], tip[1], a, 17, dir * 6, 4).slice(1),
        ...limb(tip[0], tip[1], a, 17, -dir * 6, 4)
          .slice(1, 3)
          .reverse(),
        tip,
      ];
    };
    return {
      strokes: [
        { c: 'a', pts: pot },
        { c: 'b', pts: stem },
        { c: 'b', pts: leaf(-1, lf.l) },
        { c: 'b', pts: leaf(1, lf.r) },
      ],
      eyes: { x: 50, y: 64 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0, 2, 3),
};
